module.exports = __webpack_public_path__ + "assets/img/b272-cm.svg";